import React from "react";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const formatDate = date => moment(date).format("DD/MM/YYYY HH:mm:ss");

const AlertMessageText = ({ classes, messages }) => {
  if (!messages || messages === "") {
    return (
      <Typography variant="body2" className={classes.message}>
        Aucune message
      </Typography>
    );
  }

  return messages.split(";").map((m, i) => (
    // eslint-disable-next-line
    <Typography variant="body2" className={classes.message} key={i}>
      {m}
    </Typography>
  ));
};

const AlertListField = ({ classes, alerts = [] }) => {
  if (alerts && alerts.length > 0) {
    return (
      <ul className={classes.alertContainer}>
        {alerts.slice(0, 10).map(item => (
          <li key={item.timestamp} className={classes.alertItem}>
            <Typography variant="caption">
              {formatDate(item.timestamp)}
            </Typography>
            <div className={classes.messageContainer}>
              <AlertMessageText messages={item.message} classes={classes} />
            </div>
          </li>
        ))}
      </ul>
    );
  }
  return <div>Aucune alerte</div>;
};

const styles = () => ({
  alertContainer: {
    paddingLeft: 8,
    margin: 0,
    padding: 0,
    listStyle: "none",
  },
  messageContainer: {
    marginLeft: 10,
  },
  alertItem: {
    marginBottom: 5,
  },
  message: {
    margin: 0,
    padding: 0,
  },
});

export default withStyles(styles)(AlertListField);



// WEBPACK FOOTER //
// ./src/components/alertListField.js